import "./App.css";
import { Routes, Route, Link } from "react-router-dom";
import { Component } from "react";
import prismsPyramids from "./images/prismsPyramids.png";
import prismsPyramids2 from "./images/sub-images/prisms-and-pyramids-2.png";
import amazon from "./images/amazon3.png";
import activityBook from "./images/activityBook.png";

class PrismsPyramid extends Component {
  constructor(props) {
    super(props);
  }

  componentDidMount = () => {
    window.scrollTo(0, 0);
    document.title = "Math Art Projects | Prisms & Pyramids";
  };

  render() {
    /////// DESKTOP //////////

    if (this.props.appState.size === "desktop") {
      return (
        <div className="desktop">
          <h1
            style={{ fontSize: "28pt", fontWeight: "600", marginBottom: "0px" }}
          >
            Prisms & Pyramids
          </h1>
          <br />
          <div
            style={{
              textAlign: "center",
              fontSize: "14pt",
              marginLeft: "15%",
              marginRight: "15%",
            }}
          >
            <img src={prismsPyramids} alt="prisms pyramids math art project" />
            <div style={{ textAlign: "left" }}>
              <p>
                This lesson teaches students how to identify differences between
                two types of three-dimensional shapes: prisms and pyramids. It
                also teaches students to identify and count each shape’s edges,
                vertexes, and faces. Students will create a total of three
                prisms and three pyramids.
              </p>
              <p>
                The teacher should begin by showing students a number of
                pre-constructed prisms and pyramids. Call on some students to
                describe what they notice to be the difference between the two
                types of three-dimensional shapes. Most students will quickly
                recognize that prisms have a flat top, while pyramids have a
                pointed top. The teacher should make sure that students also
                realize that the sides of prisms are rectangles (or
                parallelograms), while the sides of pyramids are triangles.
              </p>
              <p>
              The teacher should also explain to students the difference between an edge, a face, and a vertex. The diagram below, drawn by the teacher and displayed at the front of the room, will help students understand these words.
              </p>
              <p className="center"><img src={prismsPyramids2} /></p>
              <br />
            </div>
            <a href="https://www.amazon.com/Math-Art-Hands-Activities-Grades/dp/1453636439/">
              <img
                src={amazon}
                alt="Buy book on Amazon"
                style={{ width: "200px" }}
              />
            </a>
            <br />
            <br />

            <div style={{ fontSize: "18pt", fontWeight: "600" }}>
              The complete activity book includes:
            </div>
            <br />
            <ul style={{ textAlign: "left", width: "500px", margin: "auto" }}>
              <li style={{ color: "yellow" }}>
                27 arts-integrated math lessons
              </li>
              <li style={{ color: "violet" }}>
                Easy-to-photocopy blackline masters
              </li>
              <li style={{ color: "yellow" }}>
                Back-of-the-book index of key terms
              </li>
              <li style={{ color: "violet" }}>
                Recommended grade-level breakdown
              </li>
              <li style={{ color: "yellow" }}>
                NCTM Standards Alignment Chart
              </li>
              <li style={{ color: "violet" }}>
                Clearly stated lesson objectives
              </li>
              <li style={{ color: "yellow" }}>
                Easy-to-follow project descriptions and diagrams
              </li>
              <li style={{ color: "violet" }}>
                Reproducible assessment sheets for every lesson (requiring
                students to explain their mathematical thinking in writing)
              </li>
            </ul>
            <br />
            <a href="https://www.amazon.com/Math-Art-Hands-Activities-Grades/dp/1453636439/">
              <img
                style={{ width: "300px" }}
                src={activityBook}
                alt="math art activity book"
              />
            </a>
            <br />
            <br />
            <div style={{ fontSize: "12pt" }}>
              Copyright © 2022 by Zachary J. Brewer
            </div>
            <br />
            <div style={{ fontSize: "12pt" }}>
              <Link to="/">← MathArtProjects.com</Link>
            </div>
            <br />
            <br />
            <br />
            <br />
          </div>
        </div>
      );
    }

    /////// MOBILE //////////
    else if (this.props.appState.size === "mobile") {
      return (
        <div className="mobile">
          <h1
            style={{
              fontSize: "28pt",
              fontWeight: "600",
              marginBottom: "0px",
              marginTop: "0px",
            }}
          >
            Prisms & Pyramids
          </h1>
          <br />
          <div
            style={{
              textAlign: "center",
              fontSize: "14pt",
            }}
          >
            <img
              src={prismsPyramids}
              alt="prisms pyramids math art project"
              style={{ width: "270px" }}
            />
            <div style={{ textAlign: "left" }}>
              <p>
                This lesson teaches students how to identify differences between
                two types of three-dimensional shapes: prisms and pyramids. It
                also teaches students to identify and count each shape’s edges,
                vertexes, and faces. Students will create a total of three
                prisms and three pyramids.
              </p>
              <p>
                The teacher should begin by showing students a number of
                pre-constructed prisms and pyramids. Call on some students to
                describe what they notice to be the difference between the two
                types of three-dimensional shapes. Most students will quickly
                recognize that prisms have a flat top, while pyramids have a
                pointed top. The teacher should make sure that students also
                realize that the sides of prisms are rectangles (or
                parallelograms), while the sides of pyramids are triangles.
              </p>
              <p>
              The teacher should also explain to students the difference between an edge, a face, and a vertex. The diagram below, drawn by the teacher and displayed at the front of the room, will help students understand these words.
              </p>
              <p className="center"><img className="smallerWidth" src={prismsPyramids2} /></p>
              <br />
            </div>
            <a href="https://www.amazon.com/Math-Art-Hands-Activities-Grades/dp/1453636439/">
              <img
                src={amazon}
                alt="Buy book on Amazon"
                style={{ width: "200px" }}
              />
            </a>
            <br />
            <br />

            <div style={{ fontSize: "18pt", fontWeight: "600" }}>
              The complete activity book includes:
            </div>
            <br />
            <ul style={{ textAlign: "left", margin: "auto" }}>
              <li style={{ color: "yellow" }}>
                27 arts-integrated math lessons
              </li>
              <li style={{ color: "violet" }}>
                Easy-to-photocopy blackline masters
              </li>
              <li style={{ color: "yellow" }}>
                Back-of-the-book index of key terms
              </li>
              <li style={{ color: "violet" }}>
                Recommended grade-level breakdown
              </li>
              <li style={{ color: "yellow" }}>
                NCTM Standards Alignment Chart
              </li>
              <li style={{ color: "violet" }}>
                Clearly stated lesson objectives
              </li>
              <li style={{ color: "yellow" }}>
                Easy-to-follow project descriptions and diagrams
              </li>
              <li style={{ color: "violet" }}>
                Reproducible assessment sheets for every lesson (requiring
                students to explain their mathematical thinking in writing)
              </li>
            </ul>
            <br />
            <a href="https://www.amazon.com/Math-Art-Hands-Activities-Grades/dp/1453636439/">
              <img
                style={{ width: "270px" }}
                src={activityBook}
                alt="math art activity book"
              />
            </a>
            <br />
            <br />
            <div style={{ fontSize: "12pt" }}>
              Copyright © 2022 by Zachary J. Brewer
            </div>
            <br />
            <div style={{ fontSize: "12pt" }}>
              <Link to="/">← MathArtProjects.com</Link>
            </div>
            <br />
            <br />
            <br />
            <br />
          </div>
        </div>
      );
    } else {
      return <div></div>;
    }
  }
}

export default PrismsPyramid;
